import React, { useState,useEffect } from "react";
import { configData } from "../config";
import { useNavigate,useLocation ,useParams } from 'react-router-dom';
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import SalespersonSidebar from './SalespersonSidebar';



const EditProductPackage = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const { id } = useParams(); 
    
  
    
    const initialPackageForm = {
        exe_package_name: '',
    }

    const [isLoading, setIsLoading] = useState(true); 
    const [formData, setFormData] = useState(initialPackageForm);
    const [errors, setErrors] = useState([]); 

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
        
    };

    useEffect(() => {
        Promise.all([
            retrievepackagedetailedview()
        ])
        .then(() => {
     
            setIsLoading(false);
        })
     
    },[]);
    async function  retrievepackagedetailedview() {
         
         
         const response = await fetch(
           app_url+'smwwcommerceproduct/getpackagedetailedview?id='+id,
           {
             method: "GET",
       
             headers: {
               'Content-Type': 'application/json',
             },
           }
         )
         const responsedata = await response.json();
         if(responsedata.data.msg == "Success") {
            
            const updatedForm = {
                exe_package_name: responsedata.data.result.name,
                id:id
            };
     
            setFormData(updatedForm);
    
         
         }
       
       }
  const validateForm = () => {
  const newMessages = [];
  if (!formData.exe_package_name) {
    newMessages.push("Executive Package Name is required.");
  }
  setErrors(newMessages);         
  return newMessages.length === 0;
     
  };
    const handleSubmit = async (e) => {
        e.preventDefault(); // prevent page reload

        const isValid = validateForm();

        if (!isValid) {return};

         const response = await fetch(app_url+'smwwcommerceproduct/putpackagedetails', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: {
        'Content-Type': 'application/json',
      },
      });
      const data = await response.json();
      if(data.data.msg === "success") {
        navigate('/admin/smww-commerce/product-package-list', { state: { message: data.data.result } });
      }
    };

    return (
    <>
        {isLoading ? (
            <Loading />
        ) : (
        <div id="main">
            <Helmet><title>Edit Product Package</title></Helmet>
            <div className="left"></div>
            <div className="center left-center">
                <div>
                    {errors.length > 0 && (
                    <div 
                        className="set-message-error" 
                        style={{ 
                            background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 8px no-repeat`,
                            paddingLeft:'40px'
                        }}
                    >
                        {errors.map((item, index) => {
                            return <>{item}<br /></>
                        })}  
                        </div>
                    )}
                    <form onSubmit={handleSubmit}>
                        <label>Executive Package Name <span className="form-required">*</span></label>
                        <input 
                            style={{width:"30%", marginBottom: "16px"}} 
                            type="text" 
                            name="exe_package_name" 
                            id="exe_package_name"
                            value={formData.exe_package_name}
                            onChange={handleChange}                           
                        />
                        <br />
                        <input 
                            type="submit" 
                            id="edit-submit" 
                            name="" 
                            value="Save Package"
                            style={{width:"155px", height: "30px"}} 
                            className="form-submit" 
                        />
                    </form>
                </div>
            </div>
            <div className="right">
                <SalespersonSidebar />
            </div>
        </div>
        )}
    </>
    );

};
export default EditProductPackage;